// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-cell[data-v-4c7f0f1b]:after{border-bottom:0}.doctorCommunicationInputs[data-v-4c7f0f1b]{background-color:#fff;color:#3f9775;padding:5px 10px;border-radius:8px;box-shadow:0 0 5px 0 #c8c9cc;margin:5px;max-width:65vw}.customerCommunicationInputs[data-v-4c7f0f1b]{background-color:#3f9775;color:#fff;padding:5px 10px;border-radius:8px;margin:0 5px;max-width:65vw}[data-v-4c7f0f1b]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
